import React, {useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2 from "./Components/NaviBarv2_En";
import Footer from "./Components/Footer_En";
import {
  Container,
  Button,
  Spinner,
  Alert,
  Card,
  Badge,
  Row,
  Col
} from "react-bootstrap";



// Annual statistics by region (2018-2025)
const YEARLY_CHARTS_CONFIG = [
  {
    year: 2018,
    url: "https://datalens.yandex/csymbu7vvmaax?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2018",
  },
  {
    year: 2019,
    url: "https://datalens.yandex/xdj9uhset7owi?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2019",
  },
  {
    year: 2020,
    url: "https://datalens.yandex/dtzvp0xf3m1ky?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2020",
  },
  {
    year: 2021,
    url: "https://datalens.yandex/n3953q5nbum08?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2021",
    description: "ARVI morbidity map by regions of Russia"
  },
  {
    year: 2022,
    url: "https://datalens.yandex/xdjgmuro8tk4i?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2022",
  },
  {
    year: 2023,
    url: "https://datalens.yandex/0gmjs8mmio66l?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2023",
  },
  {
    year: 2024,
    url: "https://datalens.yandex/r7daqn3pybvwc?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2024",
  },
  {
    year: 2025,
    url: "https://datalens.yandex/r7dawm21dr4kc?data_olfk=&region_sehj=&_embedded=1&_no_controls=1",
    title: "Regional disease statistics for 2025",
  }
];

// Statistics by region (
const REGION_STATS_CONFIG = [
  {
    id: 'regions-morbidity',
    title: "Morbidity by region",
    description: "ARVI morbidity statistics across all regions of Russia",
    url: "https://datalens.yandex/zfrkdo6xblhsk?data_olfk=&region_sehj=%D0%90%D0%BB%D1%82%D0%B0%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%90%D0%BC%D1%83%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%90%D1%80%D1%85%D0%B0%D0%BD%D0%B3%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%90%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%91%D0%B5%D0%BB%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%91%D1%80%D1%8F%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BE%D0%BB%D0%B3%D0%BE%D0%B3%D1%80%D0%B0%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BE%D0%BB%D0%BE%D0%B3%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BE%D1%80%D0%BE%D0%BD%D0%B5%D0%B6%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%B3.%20%D0%A1%D0%B5%D0%B2%D0%B0%D1%81%D1%82%D0%BE%D0%BF%D0%BE%D0%BB%D1%8C&region_sehj=%D0%95%D0%B2%D1%80%D0%B5%D0%B9%D1%81%D0%BA%D0%B0%D1%8F%20%D0%90%D0%9E&region_sehj=%D0%97%D0%B0%D0%B1%D0%B0%D0%B9%D0%BA%D0%B0%D0%BB%D1%8C%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%98%D0%B2%D0%B0%D0%BD%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%98%D1%80%D0%BA%D1%83%D1%82%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%82%D1%8C&region_sehj=%D0%9A%D0%B0%D0%B1%D0%B0%D1%80%D0%B4%D0%B8%D0%BD%D0%BE-%D0%91%D0%B0%D0%BB%D0%BA%D0%B0%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%9A%D0%B0%D0%BB%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3%D1%80%D0%B0%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B0%D0%BB%D1%83%D0%B6%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B0%D0%BC%D1%87%D0%B0%D1%82%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9A%D0%B0%D1%80%D0%B0%D1%87%D0%B0%D0%B5%D0%B2%D0%BE-%D0%A7%D0%B5%D1%80%D0%BA%D0%B5%D1%81%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%9A%D0%B5%D0%BC%D0%B5%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B8%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%BE%D1%81%D1%82%D1%80%D0%BE%D0%BC%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D0%B4%D0%B0%D1%80%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D1%8F%D1%80%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9A%D1%83%D1%80%D0%B3%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D1%83%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9B%D0%B5%D0%BD%D0%B8%D0%BD%D0%B3%D1%80%D0%B0%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9B%D0%B8%D0%BF%D0%B5%D1%86%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9C%D0%B0%D0%B3%D0%B0%D0%B4%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0&region_sehj=%D0%9C%D0%BE%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9C%D1%83%D1%80%D0%BC%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9D%D0%B8%D0%B6%D0%B5%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9D%D0%BE%D0%B2%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9D%D0%BE%D0%B2%D0%BE%D1%81%D0%B8%D0%B1%D0%B8%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9E%D0%BC%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9E%D1%80%D0%B5%D0%BD%D0%B1%D1%83%D1%80%D0%B3%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9E%D1%80%D0%BB%D0%BE%D0%B2%D1%81%D0%BD%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9F%D0%B5%D0%BD%D0%B7%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9F%D0%B5%D1%80%D0%BC%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9F%D1%80%D0%B8%D0%BC%D0%BE%D1%80%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9F%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%90%D0%B4%D1%8B%D0%B3%D0%B5%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%90%D0%BB%D1%82%D0%B0%D0%B9&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%91%D0%B0%D1%88%D0%BA%D0%BE%D1%80%D1%82%D0%BE%D1%81%D1%82%D0%B0%D0%BD&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%91%D1%83%D1%80%D1%8F%D1%82%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%94%D0%B0%D0%B3%D0%B5%D1%81%D1%82%D0%B0%D0%BD&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%98%D0%BD%D0%B3%D1%83%D1%88%D0%B5%D1%82%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D0%B0%D0%BB%D0%BC%D1%8B%D0%BA%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D0%B0%D1%80%D0%B5%D0%BB%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D0%BE%D0%BC%D0%B8&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D1%80%D1%8B%D0%BC&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9C%D0%B0%D1%80%D0%B8%D0%B9%20%D0%AD%D0%BB&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9C%D0%BE%D1%80%D0%B4%D0%BE%D0%B2%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A1%D0%B0%D1%85%D0%B0%20(%D0%AF%D0%BA%D1%83%D1%82%D0%B8%D1%8F)&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%B0%D1%8F%20%D0%9E%D1%81%D0%B5%D1%82%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A2%D0%B0%D1%82%D0%B0%D1%80%D1%81%D1%82%D0%B0%D0%BD&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A2%D1%8B%D0%B2%D0%B0&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A5%D0%B0%D0%BA%D0%B0%D1%81%D0%B8%D1%8F&region_sehj=%D0%A0%D0%BE%D1%81%D1%82%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A0%D1%8F%D0%B7%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B0%D0%BC%D0%B0%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B0%D0%BD%D0%BA%D1%82-%D0%9F%D0%B5%D1%82%D0%B5%D1%80%D0%B1%D1%83%D1%80%D0%B3&region_sehj=%D0%A1%D0%B0%D1%80%D0%B0%D1%82%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B0%D1%85%D0%B0%D0%BB%D0%B8%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B2%D0%B5%D1%80%D0%B4%D0%BB%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%BC%D0%BE%D0%BB%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D1%82%D0%B0%D0%B2%D1%80%D0%BE%D0%BF%D0%BE%D0%BB%D1%8C%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%A2%D0%B0%D0%BC%D0%B1%D0%BE%D0%B2%D1%81%D0%BD%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D0%B2%D0%B5%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D0%BE%D0%BC%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D1%83%D0%BB%D1%8C%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D1%8E%D0%BC%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A3%D0%B4%D0%BC%D1%83%D1%80%D1%82%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%A3%D0%BB%D1%8C%D1%8F%D0%BD%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A5%D0%B0%D0%B1%D0%B0%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%A5%D0%B0%D0%BD%D1%82%D1%8B-%D0%9C%D0%B0%D0%BD%D1%81%D0%B8%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D0%90%D0%9E&region_sehj=%D0%A7%D0%B5%D0%BB%D1%8F%D0%B1%D0%B8%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A7%D0%B5%D1%87%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%A7%D1%83%D0%B2%D0%B0%D1%88%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BD%D0%B0&region_sehj=%D0%AF%D0%BC%D0%B0%D0%BB%D0%BE-%D0%9D%D0%B5%D0%BD%D0%B5%D1%86%D0%BA%D0%B8%D0%B9%20%D0%90%D0%9E&region_sehj=%D0%AF%D1%80%D0%BE%D1%81%D0%BB%D0%B0%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&_embedded=1&_no_controls=1",
    color: "primary"
  },
  {
    id: 'regions-research',
    title: "Research by region",
    description: "Analysis and research of morbidity by regions of Russia",
    url: "https://datalens.yandex/s8kgsvwtohwed?data_olfk=&region_sehj=%D0%90%D0%BB%D1%82%D0%B0%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%90%D0%BC%D1%83%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%90%D1%80%D1%85%D0%B0%D0%BD%D0%B3%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%90%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%91%D0%B5%D0%BB%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%91%D1%80%D1%8F%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BE%D0%BB%D0%B3%D0%BE%D0%B3%D1%80%D0%B0%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BE%D0%BB%D0%BE%D0%B3%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%92%D0%BE%D1%80%D0%BE%D0%BD%D0%B5%D0%B6%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%B3.%20%D0%A1%D0%B5%D0%B2%D0%B0%D1%81%D1%82%D0%BE%D0%BF%D0%BE%D0%BB%D1%8C&region_sehj=%D0%95%D0%B2%D1%80%D0%B5%D0%B9%D1%81%D0%BA%D0%B0%D1%8F%20%D0%90%D0%9E&region_sehj=%D0%97%D0%B0%D0%B1%D0%B0%D0%B9%D0%BA%D0%B0%D0%BB%D1%8C%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%98%D0%B2%D0%B0%D0%BD%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%98%D1%80%D0%BA%D1%83%D1%82%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B0%D0%B1%D0%B0%D1%80%D0%B4%D0%B8%D0%BD%D0%BE-%D0%91%D0%B0%D0%BB%D0%BA%D0%B0%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%9A%D0%B0%D0%BB%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3%D1%80%D0%B0%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B0%D0%BB%D1%83%D0%B6%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B0%D0%BC%D1%87%D0%B0%D1%82%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9A%D0%B0%D1%80%D0%B0%D1%87%D0%B0%D0%B5%D0%B2%D0%BE-%D0%A7%D0%B5%D1%80%D0%BA%D0%B5%D1%81%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%9A%D0%B5%D0%BC%D0%B5%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%B8%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D0%BE%D1%81%D1%82%D1%80%D0%BE%D0%BC%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D0%B4%D0%B0%D1%80%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D1%8F%D1%80%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9A%D1%83%D1%80%D0%B3%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9A%D1%83%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9B%D0%B5%D0%BD%D0%B8%D0%BD%D0%B3%D1%80%D0%B0%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9B%D0%B8%D0%BF%D0%B5%D1%86%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9C%D0%B0%D0%B3%D0%B0%D0%B4%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0&region_sehj=%D0%9C%D0%BE%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9C%D1%83%D1%80%D0%BC%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9D%D0%B8%D0%B6%D0%B5%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9D%D0%BE%D0%B2%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9D%D0%BE%D0%B2%D0%BE%D1%81%D0%B8%D0%B1%D0%B8%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9E%D0%BC%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9E%D1%80%D0%B5%D0%BD%D0%B1%D1%83%D1%80%D0%B3%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9E%D1%80%D0%BB%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9F%D0%B5%D0%BD%D0%B7%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%9F%D0%B5%D1%80%D0%BC%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9F%D1%80%D0%B8%D0%BC%D0%BE%D1%80%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%9F%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%90%D0%B4%D1%8B%D0%B3%D0%B5%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%90%D0%BB%D1%82%D0%B0%D0%B9&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%91%D0%B0%D1%88%D0%BA%D0%BE%D1%80%D1%82%D0%BE%D1%81%D1%82%D0%B0%D0%BD&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%91%D1%83%D1%80%D1%8F%D1%82%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%94%D0%B0%D0%B3%D0%B5%D1%81%D1%82%D0%B0%D0%BD&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%98%D0%BD%D0%B3%D1%83%D1%88%D0%B5%D1%82%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D0%B0%D0%BB%D0%BC%D1%8B%D0%BA%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D0%B0%D1%80%D0%B5%D0%BB%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D0%BE%D0%BC%D0%B8&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9A%D1%80%D1%8B%D0%BC&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9C%D0%B0%D1%80%D0%B8%D0%B9%20%D0%AD%D0%BB&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%9C%D0%BE%D1%80%D0%B4%D0%BE%D0%B2%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A1%D0%B0%D1%85%D0%B0%20(%D0%AF%D0%BA%D1%83%D1%82%D0%B8%D1%8F)&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A1%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D0%B0%D1%8F%20%D0%9E%D1%81%D0%B5%D1%82%D0%B8%D1%8F&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A2%D0%B0%D1%82%D0%B0%D1%80%D1%81%D1%82%D0%B0%D0%BD&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A2%D1%8B%D0%B2%D0%B0&region_sehj=%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0%20%D0%A5%D0%B0%D0%BA%D0%B0%D1%81%D0%B8%D1%8F&region_sehj=%D0%A0%D0%BE%D1%81%D1%82%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A0%D1%8F%D0%B7%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B0%D0%BC%D0%B0%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B0%D0%BD%D0%BA%D1%82-%D0%9F%D0%B5%D1%82%D0%B5%D1%80%D0%B1%D1%83%D1%80%D0%B3&region_sehj=%D0%A1%D0%B0%D1%80%D0%B0%D1%82%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B0%D1%85%D0%B0%D0%BB%D0%B8%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%B2%D0%B5%D1%80%D0%B4%D0%BB%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D0%BC%D0%BE%D0%BB%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A1%D1%82%D0%B0%D0%B2%D1%80%D0%BE%D0%BF%D0%BE%D0%BB%D1%8C%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%A2%D0%B0%D0%BC%D0%B1%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D0%B2%D0%B5%D1%80%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D0%BE%D0%BC%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D1%83%D0%BB%D1%8C%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A2%D1%8E%D0%BC%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A3%D0%B4%D0%BC%D1%83%D1%80%D1%82%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%A3%D0%BB%D1%8C%D1%8F%D0%BD%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A5%D0%B0%D0%B1%D0%B0%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BA%D1%80%D0%B0%D0%B9&region_sehj=%D0%A5%D0%B0%D0%BD%D1%82%D1%8B-%D0%9C%D0%B0%D0%BD%D1%81%D0%B8%D0%B9%D1%81%D0%BA%D0%B8%D0%B9%20%D0%90%D0%9E&region_sehj=%D0%A7%D0%B5%D0%BB%D1%8F%D0%B1%D0%B8%D0%BD%D1%81%D0%BD%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&region_sehj=%D0%A7%D0%B5%D1%87%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%A7%D1%83%D0%B2%D0%B0%D1%88%D1%81%D0%BA%D0%B0%D1%8F%20%D0%A0%D0%B5%D1%81%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%B0&region_sehj=%D0%AF%D0%BC%D0%B0%D0%BB%D0%BE-%D0%9D%D0%B5%D0%BD%D0%B5%D1%86%D0%BA%D0%B8%D0%B9%20%D0%90%D0%9E&region_sehj=%D0%AF%D1%80%D0%BE%D1%81%D0%BB%D0%B0%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C&_embedded=1&_no_controls=1",
    color: "success"
  }
];

// 4 блока аналитики 
const ANALYTICS_CHARTS_CONFIG = [
  {
    id: 'analytics-1',
    url: "https://datalens.yandex/t8ammkz5pze4e?_embedded=1&_no_controls=1",
  
  },
  {
    id: 'analytics-2',
    url: "https://datalens.yandex/gw7yc1ehvta61?_embedded=1&_no_controls=1",

  },
  {
    id: 'analytics-3',
    url: "https://datalens.yandex/8ozlidfr5ikit?_embedded=1&_no_controls=1",

  },
  {
    id: 'analytics-4',
    url: "https://datalens.yandex/xdof2t62opyoi?_embedded=1&_no_controls=1",

  }
];

// 4. Все случаи по неделям
const WEEKLY_CHART_CONFIG = {
  url: "https://datalens.yandex/0grjjwzm36r2l?_embedded=1&_no_controls=1",

};


// Компонент для одного графика
const ChartFrame = ({ url, title, height = "400px" }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  return (
    <div style={{ 
      position: 'relative', 
      width: '100%',
      height: height,
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      overflow: 'hidden'
    }}>
      {/* Индикатор загрузки */}
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1,
          textAlign: 'center'
        }}>
          <Spinner animation="border" variant="primary" size="sm" />
          <div className="mt-2 text-muted" style={{ fontSize: '0.8em' }}>Loading...</div>
        </div>
      )}
      
      {/* Сообщение об ошибке */}
      {hasError && (
        <Alert 
          variant="warning" 
          style={{ 
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            fontSize: '0.9em'
          }}
        >
          <Alert.Heading>Loading error</Alert.Heading>
          <p>Failed to load the report.</p>
        </Alert>
      )}
      
      {/* Iframe */}
      <iframe
        src={url}
        width="100%"
        height="100%"
        frameBorder="0"
        title={title}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setHasError(true);
        }}
        style={{
          border: 'none',
          display: hasError ? 'none' : 'block'
        }}
        allowFullScreen
      />
    </div>
  );
};

// Панель выбора года
const YearSelector = ({ selectedYear, onYearSelect }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="d-flex flex-wrap gap-2 mb-4 justify-content-center">
      {YEARLY_CHARTS_CONFIG.map((chart) => {
        const isCurrentYear = chart.year === currentYear;
        const isSelected = chart.year === selectedYear;
        
        return (
          <Button
            key={chart.year}
            variant={isSelected ? 'primary' : 'outline-primary'}
            size="lg"
            className="px-3 py-2"
            onClick={() => onYearSelect(chart.year)}
            style={{
              fontWeight: '600',
              minWidth: '90px'
            }}
          >
            {chart.year}
            {isCurrentYear && !isSelected && (
              <span 
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ fontSize: '0.5em' }}
              >
                •
              </span>
            )}
          </Button>
        );
      })}
    </div>
  );
};

// Панель выбора статистики по регионам - 2кнопки
const RegionStatsSelector = ({ selectedStat, onStatSelect }) => {
  return (
    <div className="d-flex gap-3 mb-4 justify-content-center">
      {REGION_STATS_CONFIG.map((stat) => {
        const isSelected = stat.id === selectedStat;
        
        return (
          <Button
            key={stat.id}
            variant={isSelected ? stat.color : `outline-${stat.color}`}
            size="lg"
            className="px-4 py-3"
            onClick={() => onStatSelect(stat.id)}
            style={{
              fontWeight: '600',
              minWidth: '220px'
            }}
          >
            {stat.title}
          </Button>
        );
      })}
    </div>
  );
};


export function Orvi_En() {
  // Годы с готовыми дашбордами. По умолчанию — текущий год, если он есть, иначе последний доступный.
  const availableYears = YEARLY_CHARTS_CONFIG.map((chart) => chart.year);
  const latestYear = Math.max(...availableYears);
  const currentYear = new Date().getFullYear();
  const defaultYear = availableYears.includes(currentYear) ? currentYear : latestYear;
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  const [selectedRegionStat, setSelectedRegionStat] = useState('regions-morbidity');
  
  // Находим выбранный график
  const selectedChart = YEARLY_CHARTS_CONFIG.find(
    chart => chart.year === selectedYear
  ) || YEARLY_CHARTS_CONFIG[YEARLY_CHARTS_CONFIG.length - 1];

  // Находим выбранную статистику по регионам
  const selectedRegionChart = REGION_STATS_CONFIG.find(
    stat => stat.id === selectedRegionStat
  ) || REGION_STATS_CONFIG[0];

  return (
    <div className="App">
      <NaviBarv2 />
      
      <Container className="py-4">
        {/* Заголовок страницы */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3">ARVI disease analytics</h1>
          <p className="text-muted">
            Statistics and monitoring of morbidity by regions of Russia
          </p>
        </div>

        {/* Годовая статистика*/}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Annual statistics by region</h2>
            <p className="text-muted">Select a year to view the morbidity map</p>
          </div>

          {/* Панель выбора года */}
          <YearSelector 
            selectedYear={selectedYear}
            onYearSelect={setSelectedYear}
          />
          
          {/* Отображение выбранного графика */}
          <Card className="border-0 shadow mb-4">
            <Card.Header className="py-3 bg-primary text-white">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="mb-0 fw-bold">{selectedChart.title}</h4>
                  <p className="mb-0 opacity-75">{selectedChart.description}</p>
                </div>
                <Badge bg="light" text="dark" className="fs-6 px-3 py-2">
                  {selectedYear}
                </Badge>
              </div>
            </Card.Header>
            
            <Card.Body className="p-3">
              <ChartFrame 
                url={selectedChart.url}
                title={selectedChart.title}
                height="500px"
              />
            </Card.Body>
          </Card>
        </div>

   
        {/* Блоки аналитика*/}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Additional analytics</h2>
          </div>

          <Row>
            {ANALYTICS_CHARTS_CONFIG.map((chart) => (
              <Col key={chart.id} md={6} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                  <Card.Header className="py-2 bg-light">
                    <h5 className="mb-0 fw-bold">{chart.title}</h5>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.85em' }}>
                      {chart.description}
                    </p>
                  </Card.Header>
                  
                  <Card.Body className="p-3">
                    <ChartFrame 
                      url={chart.url}
                      title={chart.title}
                      height="150px" 
                    />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Случаи по неделям*/}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Weekly statistics</h2>
          </div>

          <Card className="border-0 shadow">
            <Card.Header className="py-3 bg-success text-white">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="mb-0 fw-bold">{WEEKLY_CHART_CONFIG.title}</h4>
                  <p className="mb-0 opacity-75">{WEEKLY_CHART_CONFIG.description}</p>
                </div>
                <Badge bg="light" text="dark" className="fs-6 px-3 py-2">
                  Weekly statistics
                </Badge>
              </div>
            </Card.Header>
            
            <Card.Body className="p-3">
              <ChartFrame 
                url={WEEKLY_CHART_CONFIG.url}
                title={WEEKLY_CHART_CONFIG.title}
                height="300px"
              />
            </Card.Body>
          </Card>
        </div>
     {/* Statistics by region*/}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Statistics by region</h2>
            <p className="text-muted">Select a statistics type to view</p>
          </div>

          {/* Панель выбора типа статистики */}
          <RegionStatsSelector 
            selectedStat={selectedRegionStat}
            onStatSelect={setSelectedRegionStat}
          />
          
          {/* Отображение выбранной статистики */}
          <Card className="border-0 shadow mb-4">
            <Card.Header 
              className="py-3 text-white"
              style={{ 
                background: selectedRegionChart.color === 'primary' 
                  ? 'linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%)'
                  : 'linear-gradient(135deg, #198754 0%, #157347 100%)'
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="mb-0 fw-bold">{selectedRegionChart.title}</h4>
                  <p className="mb-0 opacity-75">{selectedRegionChart.description}</p>
                </div>
                <Badge bg="light" text="dark" className="fs-6 px-3 py-2">
                  {selectedRegionChart.id === 'regions-morbidity' ? 'Morbidity' : 'Research'}
                </Badge>
              </div>
            </Card.Header>
            
            <Card.Body className="p-3">
              <ChartFrame 
                url={selectedRegionChart.url}
                title={selectedRegionChart.title}
                height="600px"
              />
            </Card.Body>
          </Card>
        </div>
        {/* СТАТИСТИКА ПО ПОИСКОВЫМ МАРКЕРАМ */}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold"> Search-query statistics</h2>
          </div>

          {/* График 1: Search-query trends - отдельная строка */}
          <div className="mb-4">
            <Card className="border-0 shadow">
              <Card.Header className="py-3 bg-info text-white">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="mb-0 fw-bold">Search-query trends</h4>
                  </div>
                  <Badge bg="light" text="dark" className="fs-6 px-3 py-2">
                    Search activity
                  </Badge>
                </div>
              </Card.Header>
              
              <Card.Body className="p-3">
                <div style={{ 
                  position: 'relative', 
                  width: '100%',
                  height: '400px',
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <iframe
                    src="https://datalens.yandex/k0czy0sz5ibu5?region_sehj=&_embedded=1&_no_controls=1"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    title="Search-query trends"
                    style={{
                      border: 'none',
                      display: 'block'
                    }}
                    allowFullScreen
                  />
                </div>
              </Card.Body>
            </Card>
          </div>

          {/* Regional comparison over time - отдельная строка */}
          <div className="mb-4">
            <Card className="border-0 shadow">
              <Card.Header className="py-3 bg-warning text-dark">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="mb-0 fw-bold">Regional comparison over time</h4>
                  </div>
                  <Badge bg="light" text="dark" className="fs-6 px-3 py-2">
                    Regional analysis
                  </Badge>
                </div>
              </Card.Header>
              
              <Card.Body className="p-3">
                <div style={{ 
                  position: 'relative', 
                  width: '100%',
                  height: '400px',
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <iframe
                    src="https://datalens.yandex/n3gdwdps0nx88?region_sehj=&_embedded=1&_no_controls=1"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    title="Regional comparison over time"
                    style={{
                      border: 'none',
                      display: 'block'
                    }}
                    allowFullScreen
                  />
                </div>
              </Card.Body>
            </Card>
          </div>

          {/* График 3: Top search queries - отдельная строка */}
          <div className="mb-4">
            <Card className="border-0 shadow">
              <Card.Header className="py-3 bg-danger text-white">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="mb-0 fw-bold">Top search queries</h4>
                  </div>
                  <Badge bg="light" text="dark" className="fs-6 px-3 py-2">
                    Top queries
                  </Badge>
                </div>
              </Card.Header>
              
              <Card.Body className="p-3">
                <div style={{ 
                  position: 'relative', 
                  width: '100%',
                  height: '400px',
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <iframe
                    src="https://datalens.yandex/7n0djbnmtq00s?region_sehj=&_embedded=1&_no_controls=1"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    title="Top search queries"
                    style={{
                      border: 'none',
                      display: 'block'
                    }}
                    allowFullScreen
                  />
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>

      </Container>
      
      <Footer />
    </div>
  );
}

export default Orvi_En;